import React, { useEffect, useState, useCallback, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import Loader from '../loading';
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ShopStore from '../DataRepository/ShopStore';
import {
    Button, CircularProgress, IconButton, Tooltip, Drawer, Box, TextField, FormControl,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    InputLabel,
    Checkbox,
    Slider,
    Typography,
    Select,
    MenuItem,
    Stack,
    OutlinedInput,
    Autocomplete,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Chip,
} from '@mui/material'
import { toast, Zoom } from "react-toastify";
import AddIcon from "@mui/icons-material/Add";
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ChevronLeft from '@mui/icons-material/ChevronLeft'
import DeleteIcon from "@mui/icons-material/Delete";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import usePrescriptionStore from '../DataRepository/Prescription'
import { profileModel } from '../Axios/AxiosConfig'


function MedicineRecommendations() {

    const {
        symptoms,
        Medicineinputs,
        setMedicineinputs,
        MedicineRecommendationLoading,
        medicinerecommendation
    } = usePrescriptionStore();

    const { Products, getProducts, isLoading, getProductsByType, page, setPage, getSearchedResults, SearchResults } = ShopStore();

    const navigate = useNavigate();

    const [open, setOpen] = useState(false);

    const [selectedIndex, setSelectedIndex] = useState(null);

    const [selectedProductCategory, setSelectedProductCategory] = useState("All");

    const [herbalproducstsloading, setherbalproducstsloading] = useState(false);

    const [Search, setsearch] = useState("");

    const observer = useRef();

    const lastPostElementRef = useCallback(
        (node) => {
            if (herbalproducstsloading) return;
            if (observer.current) observer.current.disconnect();

            observer.current = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting) {
                    setPage();
                }
            });

            if (node) observer.current.observe(node);
        },
        [herbalproducstsloading]
    );

    const loadMoreProducts = async () => {
        setherbalproducstsloading(true);
        getProducts()
        setherbalproducstsloading(false);
    };

    useEffect(() => {
        if (selectedProductCategory === 'All') {
            loadMoreProducts()
        }
        else {
            getProductsByType(selectedProductCategory, "")
        }

    }, [page, selectedProductCategory]);


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleSelectMultipleProducts = (product) => {

        const existingIndex = Medicineinputs.findIndex((item) => item.id === product.id);

        if (existingIndex !== -1) {
            const updated = Medicineinputs.filter((item) => item.id !== product.id);
            setMedicineinputs(updated);
            return;
        }

        const emptyIndex = Medicineinputs.findIndex((item) => !item.id && !item.medicine);

        if (emptyIndex !== -1) {
            const updated = Medicineinputs.map((item, index) =>
                index === emptyIndex
                    ? {
                        ...item,
                        id: product.id,
                        medicine: product.name,
                        companyid: product.company_id,
                        deliverycharges: product.deliverycharges,
                        sku: product.sku,
                        price: product.price,
                        desc: product.desc,
                        qty: product.qty,
                        imgurl: product.imgurl,
                        company: product.company,
                        quantity: 1,
                    }
                    : item
            );
            setMedicineinputs(updated);
            return;
        }

        const updated = [
            ...Medicineinputs,
            {
                id: product.id,
                medicine: product.name,
                companyid: product.company_id,
                deliverycharges: product.deliverycharges,
                sku: product.sku,
                price: product.price,
                desc: product.desc,
                qty: product.qty,
                imgurl: product.imgurl,
                company: product.company,
                quantity: 1,
                Reason: "",
                dose: "",
                instruction: "",
                duration: "",
                timing: "",
            },
        ];

        setMedicineinputs(updated);
    };

    const handleCloseDialog = () => {
        setOpen(false);
        setSelectedIndex(null);
    };

    const handleOpenDialog = (index) => {
        setSelectedIndex(index);
        setOpen(true);
    };

    const handleProductCategorySelect = (categoryType) => {
        setSelectedProductCategory(categoryType);
    };

    const ratings = ["None", "Mild", "Moderate", "High", "Severe", "Extreme"];

    const Categories = [
        {
            name: "All",
            img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/all_product_icon.png",
            type: "All",
        },
        {
            name: "Tablets",
            img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Tablets.png",
            type: "Tablets",
        },
        {
            name: "Powders",
            img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Powders.png",
            type: "Churna",
        },
        {
            name: "Oils",
            img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Oils.png",
            type: "Oil",
        },
        {
            name: "Ghee",
            img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Ghee.png",
            type: "Ghee",
        },
        {
            name: "Decoctions",
            img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Decoctions.png",
            type: "Kashayam (Decoctions)",
        },
        {
            name: "Fermented",
            img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Fermented.png",
            type: "Arishta",
        },
        {
            name: "Miscellaneous",
            img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Miscellaneous.png",
            type: "Miscellaneous",
        },
        {
            name: "Syrups",
            img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Syrups.png",
            type: "Syrup",
        },
        {
            name: "Tea",
            img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Tea.png",
            type: "Tea",
        },
    ];

    return <div className='All-products-section-main'>

        <nav
            className='fixed top-0 w-full z-50 flex flex-row p-2 items-center justify-between'
            style={{ backgroundColor: "#f4ecd6" }}
        >
            <div className='flex flex-row items-center'>
                <IconButton onClick={() => navigate(-1)}>
                    <ChevronLeft />
                </IconButton>
                <p
                    className='mb-0'
                    style={{
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: 500,
                    }}
                >
                    Medicines
                </p>
            </div>
        </nav>


        {MedicineRecommendationLoading ?
            <Loader loading={MedicineRecommendationLoading} />
            : <div className='flex flex-col gap-4 p-4 pt-20'>
                <div className='flex flex-col gap-4 bg-[#FAF6EC] p-4 rounded-lg'>
                    <div className='flex flex-col gap-4'>
                        <div className='flex flex-col justify-between'>
                            <div>
                                {symptoms && symptoms.length > 0 &&
                                    <div>
                                        <p className="Prescription-sh-h">Chief Complaints</p>
                                        <div style={{ padding: '1rem' }}>
                                            <TableContainer>
                                                <Table aria-label="symptoms table">
                                                    <TableHead style={{ backgroundColor: "#D4CEC3" }}>
                                                        <TableRow>
                                                            <TableCell sx={{ width: '30%' }} align="center"
                                                                style={{
                                                                    fontFamily: "'Poppins', sans-serif",
                                                                    fontWeight: 500,
                                                                    color: "#3B362A",
                                                                    fontSize: "16px",
                                                                    padding: "10px"
                                                                }}>Symptom</TableCell>
                                                            <TableCell sx={{ width: '40%' }} align="center" style={{
                                                                fontFamily: "'Poppins', sans-serif",
                                                                fontWeight: 500,
                                                                color: "#3B362A",
                                                                fontSize: "16px",
                                                                padding: "10px"
                                                            }}>Severity</TableCell>
                                                            <TableCell sx={{ width: '30%' }} align="center"
                                                                style={{
                                                                    fontFamily: "'Poppins', sans-serif",
                                                                    fontWeight: 500,
                                                                    color: "#3B362A",
                                                                    fontSize: "16px",
                                                                    padding: "10px"
                                                                }}>Duration</TableCell>
                                                            <TableCell sx={{ width: '30%' }} align="center"
                                                                style={{
                                                                    fontFamily: "'Poppins', sans-serif",
                                                                    fontWeight: 500,
                                                                    color: "#3B362A",
                                                                    fontSize: "16px",
                                                                    padding: "10px"
                                                                }}>Frequency</TableCell>
                                                            <TableCell sx={{ width: '30%' }} align="center"
                                                                style={{
                                                                    fontFamily: "'Poppins', sans-serif",
                                                                    fontWeight: 500,
                                                                    color: "#3B362A",
                                                                    fontSize: "16px",
                                                                    padding: "10px"
                                                                }}>Goal</TableCell>
                                                            <TableCell sx={{ width: '10%' }} align="center"></TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody style={{ backgroundColor: "#F8F8F4" }}>
                                                        {symptoms?.map((e, i) => (
                                                            <TableRow key={i}>
                                                                <TableCell component="th" scope="row" sx={{ width: '30%' }}>
                                                                    <p style={{
                                                                        fontFamily: "'Poppins', sans-serif",
                                                                        fontWeight: 500,
                                                                        color: "#3B362A",
                                                                        fontSize: "16px",
                                                                    }}>{e?.symptoms}</p>
                                                                </TableCell>
                                                                <TableCell sx={{ width: '40%' }}>
                                                                    <div className="flex items-center justify-center space-x-6">
                                                                        {ratings?.map((label, index) => (
                                                                            <div
                                                                                key={index}
                                                                                className="flex flex-col items-center cursor-pointer"
                                                                            >
                                                                                <div
                                                                                    className={`w-6 h-6 rounded-full transition-all duration-300 ${e?.severity >= index ? "bg-[#DA6E0B]" : "bg-gray-300"
                                                                                        }`}
                                                                                ></div>
                                                                                <span className="mt-2 text-sm text-gray-700" style={{
                                                                                    fontFamily: "'Poppins', sans-serif",
                                                                                    fontWeight: 400,
                                                                                }}>{label}</span>
                                                                            </div>
                                                                        ))}

                                                                        {/* <p style={{
                                                                                              fontFamily: "'Poppins', sans-serif",
                                                                                              fontWeight: 500,
                                                                                              color: "#3B362A",
                                                                                              fontSize: "16px",
                                                                                          }}>{ratings[e?.severity]}</p> */}

                                                                    </div>
                                                                </TableCell>
                                                                <TableCell align="center" sx={{ width: '30%' }}>
                                                                    <p style={{
                                                                        fontFamily: "'Poppins', sans-serif",
                                                                        fontWeight: 500,
                                                                        color: "#3B362A",
                                                                        fontSize: "16px",
                                                                    }}>{e?.duration}</p>
                                                                </TableCell>
                                                                <TableCell align="center" sx={{ width: '30%' }}>
                                                                    <p style={{
                                                                        fontFamily: "'Poppins', sans-serif",
                                                                        fontWeight: 500,
                                                                        color: "#3B362A",
                                                                        fontSize: "16px",
                                                                    }}>{e?.frequeny}</p>
                                                                </TableCell>
                                                                <TableCell align="center" sx={{ width: '30%' }}>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={e?.goal}
                                                                        readOnly
                                                                        onClick={(e) => e.preventDefault()}
                                                                        style={{
                                                                            width: '16px',
                                                                            height: '16px',
                                                                            accentColor: '#DA6E0B',
                                                                            cursor: 'default',
                                                                        }}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </div>
                                    </div>
                                }

                            </div>
                        </div>

                    </div>



                </div>


                {
                    medicinerecommendation.length > 0 &&
                    <div className='mt-5'>

                        <div className="flex flex-row justify-between items-center px-2" style={{
                            borderLeft: "5px solid #DA6E0B",
                            borderRadius: "8px"
                        }}>
                            <p style={{
                                fontSize: "18px",
                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 500,
                            }}>Medicine Recommendations</p>

                            <IconButton onClick={() => handleOpenDialog(null)}>
                                <AddIcon />
                            </IconButton>

                        </div>

                        <div className="herbal-products scrollbar-hide mt-5">
                            {medicinerecommendation.filter((product) => product.onsale).map((item) => {
                                const isSelected = Medicineinputs.some((e) => e?.id === item.id);
                                return (
                                    <Tooltip
                                        key={item.id}
                                        title={
                                            <span>
                                                <strong>Reason:</strong> {item?.reason}<br />
                                            </span>
                                        }

                                        arrow
                                        placement="bottom"
                                    >
                                        <div className="herbal-product-card">
                                            <div className="img-container">
                                                <img
                                                    src={item.imgurl}
                                                    alt={item.name}
                                                    onClick={() => handleSelectMultipleProducts(item)}
                                                />
                                            </div>
                                            <p>{item.name}</p>

                                            <Checkbox
                                                checked={isSelected}
                                                onClick={() => handleSelectMultipleProducts(item)}
                                                sx={{

                                                    '&.Mui-checked': {
                                                        color: '#DA6E0B',
                                                    },
                                                }}
                                            />


                                        </div>
                                    </Tooltip>
                                )
                            })

                            }
                        </div>

                    </div>
                }


                {
                    medicinerecommendation.length > 0 &&
                    <div className='m-5' style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            style={{
                                textTransform: "none",
                                backgroundColor: "#DA6E0B",
                                color: "white",
                                border: "none",
                                boxSizing: "border-box",
                                borderRadius: "5px",
                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 500,
                                padding: "10px",
                            }}
                            onClick={() => {
                                navigate(-1);
                            }}
                        >
                            Save and Proceed
                        </Button>
                    </div>
                }

                <Dialog open={open} scroll={'paper'} onClose={handleCloseDialog}
                    // ref={HerbalmedicinesElementRef}
                    fullWidth={true}
                    maxWidth={'lg'}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"

                >

                    <DialogTitle id="scroll-dialog-title">
                        <div className="flex justify-between flex-row w-auto">
                            <div className="flex flex-row items-center gap-2">
                                <IconButton onClick={handleCloseDialog}>
                                    <ArrowBackIcon />
                                </IconButton>
                                <div className="flex items-center justify-between gap-4">
                                    <p className="Prescription-sh-h">Herbal Products</p>
                                </div>
                            </div>


                            <IconButton onClick={handleCloseDialog}>
                                <CloseIcon />
                            </IconButton>
                        </div>


                    </DialogTitle>

                    <DialogContent dividers tabIndex={-1} >
                        <div className="Herbal-products-container w-auto h-full overflow-y-auto" >


                            <Autocomplete
                                multiple
                                disableCloseOnSelect
                                options={SearchResults}
                                value={Medicineinputs}
                                getOptionLabel={(option) => option.name || ''}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                onChange={(e, newValue) => setMedicineinputs(newValue)}
                                inputValue={Search}
                                onInputChange={(e, value) => setsearch(value)}
                                filterSelectedOptions
                                renderTags={() => null}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        label="Search"
                                        placeholder="Search medicine"
                                        InputProps={{
                                            ...params.InputProps,
                                            startAdornment: null
                                        }}
                                    />
                                )}

                                renderOption={(props, option, { selected }) => (
                                    <li {...props} key={option.id} onClick={() => handleSelectMultipleProducts(option)}>
                                        <Checkbox
                                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.name}
                                    </li>
                                )}
                            />

                            <div className="ListofCategories">
                                {Categories.map((category) => (
                                    <div
                                        key={category.type}
                                        onClick={() => handleProductCategorySelect(category.type)}
                                        className={`category-item ${selectedProductCategory.toLowerCase() === category.type.toLowerCase() ? "active-category" : ""
                                            }`}
                                    >
                                        <img src={category.img} alt={category.name} />
                                        <p className={selectedProductCategory.toLowerCase() === category.type.toLowerCase() ? "lineactive" : ""}>
                                            {category.name}
                                        </p>
                                    </div>
                                ))}
                            </div>

                            <div>
                                {Medicineinputs.length > 0 && (
                                    <div className="flex flex-wrap gap-2">
                                        {Medicineinputs.filter((e) => e.id).map((product) => (
                                            <Chip
                                                key={product.id}
                                                label={product.medicine}
                                                onDelete={() => handleSelectMultipleProducts(product)}
                                                sx={{
                                                    backgroundColor: "#DA6E0B",
                                                    color: "white",
                                                    "& .MuiChip-deleteIcon": { color: "white" },
                                                }}
                                                size="small"
                                                className="cursor-pointer"
                                            />
                                        ))}
                                    </div>
                                )}

                                <div className="herbal-products scrollbar-hide">
                                    {Products.filter((product) => product.onsale).map((product) => {
                                        const isSelected = Medicineinputs.some((item) => item.id === product.id);
                                        return (
                                            <div key={product.id} className="herbal-product-card" ref={lastPostElementRef}>
                                                <div className="img-container">
                                                    <img
                                                        src={product.imgurl}
                                                        alt={product.name}
                                                        onClick={() => handleSelectMultipleProducts(product)}
                                                    />
                                                </div>
                                                <p>{product.name}</p>

                                                <Checkbox
                                                    checked={isSelected}
                                                    sx={{
                                                        '&.Mui-checked': {
                                                            color: '#DA6E0B',
                                                        },
                                                        marginTop: 'auto', // Push to bottom in flex column
                                                    }}
                                                    onClick={() => handleSelectMultipleProducts(product)}
                                                />
                                            </div>

                                        );
                                    })}
                                </div>

                                {isLoading &&
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <CircularProgress style={{
                                            color: "#DA6E0B"
                                        }} />
                                    </div>
                                }
                            </div>
                        </div>
                    </DialogContent>

                </Dialog>
            </div>
        }
    </div>

}

export default MedicineRecommendations